import { config } from 'util/config';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
    sectionComponent.customForm.current?.setState({ componentDataSource: {} })
  }, config.setTimeoutMilliSecond);
}
